import { useQuery } from "@apollo/client";
import { useState, createContext, useContext, useMemo } from "react";
import { GET_TEAMS } from "services/apollo/Queries";
import { useAdmin } from "features/admin/AdminContext";

export const TeamContext = createContext();

export const TeamProvider = ({ children }) => {
    const { user, setUser, all_users, setAll_users } = useAdmin();
    const [loader, setLoader] = useState(true);
    const [activeTeam, setActiveTeam] = useState(null);
    const [filterState, setFilterState] = useState(''); // 0, 1, '', 'Admin', 'Member'
    const [searchString, setSearchString] = useState('');
    const [sort, setSort] = useState('asc');
    const [teams, setTeams] = useState([]);

    useQuery(GET_TEAMS, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            console.log(36, data);

            if (data?.teams) {
                setTeams(data.teams)
                setLoader(false)
            }
        }
    });

    const filteredUsers = useMemo(() => {
        let data = teams;

        // Filter by search string
        if (searchString) {
            const lower = searchString.toLowerCase();
            data = data.filter(t =>
                t.team_title.toLowerCase().includes(lower)
            );
        }

        // Sort by team_title (asc/desc)
        data = [...data].sort((a, b) => {
            const nameA = a.team_title.toLowerCase();
            const nameB = b.team_title.toLowerCase();

            return sort === "asc" ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
        });

        return data;
    }, [teams, searchString, sort]);

    const updateTeamData = (participants) => {
        console.log('updateTeamData:', participants);
        setActiveTeam(prev => ({ ...prev, participants: participants }));
        setTeams(prev => [...prev.map(t => t.team_id === activeTeam?.team_id ? { ...t, participants: participants } : t)]);
    }


    const contextValue = useMemo(() => ({
        loader,
        all_users,
        setAll_users,
        user,
        setUser,
        searchString,
        setSearchString,
        filterState,
        setFilterState,
        activeTeam,
        setActiveTeam,
        teams: filteredUsers,
        setTeams,
        sort,
        setSort,
        updateTeamData,
        // handleDeleteErpUser,
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [loader, all_users, user, searchString, filterState, activeTeam, teams, sort, filteredUsers, updateTeamData]);

    return (
        <TeamContext.Provider value={contextValue}>
            {children}
        </TeamContext.Provider>
    );
};

export const useTeams = () => {
    const context = useContext(TeamContext);
    if (!context) {
        throw new Error("useTeams must be used within a TeamProvider");
    }
    return context;
};